import { Button, Column, Expander, Icon } from '@amzn/meridian';
import copyTokens from '@amzn/meridian-tokens/base/icon/copy';
import { useGlobalToasterContext } from 'components/GlobalToaster/GlobalToasterContext';
import { useSpyOnFieldValue } from 'hooks/form-spy/useSpyOnFieldValue';
import { useCallback, useState } from 'react';
import type { FlavorPath } from '../../mcc.types';
import { PrettyPrintJSON } from './PrettyPrintJSON';

export const CopyCampaignContentSection = ({ pathToFlavor }: { pathToFlavor: FlavorPath }) => {
  const flavorContent = useSpyOnFieldValue<Record<string, unknown>>({
    fieldPath: `${pathToFlavor}.content`,
  });

  const [currentContentExpanderOpen, setCurrentContentExpanderOpen] = useState(false);

  const { onOpenToast } = useGlobalToasterContext();

  const handleCopyContent = useCallback(async () => {
    try {
      // Convert the flavorContent object to a formatted string
      const contentString = JSON.stringify(flavorContent, null, 2);
      // Copy the string to the clipboard using await
      await navigator.clipboard.writeText(contentString);
      onOpenToast({
        alertType: 'success',
        timeout: 2000,
        toastMessage: 'Content copied to clipboard',
      });
    } catch (error) {
      console.error('Failed to copy content to clipboard:', error);
      onOpenToast({
        alertType: 'error',
        timeout: 2000,
        toastMessage: 'Failed to copy content to clipboard.',
      });
    }
  }, [
    flavorContent,
    onOpenToast,
  ]);

  return (
    <Expander onChange={setCurrentContentExpanderOpen} open={currentContentExpanderOpen} title="Current Creative Content" type="inline">
      <PrettyPrintJSON objectToPrint={flavorContent} />
      <Column alignmentHorizontal="stretch" spacingInset={'400 none none'}>
        <Button onClick={handleCopyContent}>
          <Icon tokens={copyTokens} />
          Copy Content
        </Button>
      </Column>
    </Expander>
  );
};
